import { useEffect, useState } from "react";

export function NotifyPopup({ title, message, duration = 5000, onClose }) {
  const [visible, setVisible] = useState(false); // animacja startuje z false
  const [shouldRender, setShouldRender] = useState(true);
  const [progressWidth, setProgressWidth] = useState("100%");

  useEffect(() => {
    // Start entry animation on mount
    setTimeout(() => setVisible(true), 10);

    // Shrink progress bar after small delay
    setTimeout(() => setProgressWidth("0%"), 100);

    // Start exit sequence after full duration
    const timeout = setTimeout(() => {
      setVisible(false); // start exit
      setTimeout(() => {
        setShouldRender(false); // unmount after animation
        if (onClose) onClose();
      }, 300); // wait for exit animation
    }, duration);

    return () => clearTimeout(timeout);
  }, [duration, onClose]);

  if (!shouldRender) return null;

  return (
    <div className="w-80 h-24 fixed left-1/2 bottom-20 -translate-x-1/2 z-50">
      <div
        className={`relative w-full h-full rounded-md bg-neutral-950/75 backdrop-blur shadow-lg overflow-hidden flex flex-col items-center justify-center text-center transition-all duration-300 origin-bottom
          ${visible ? "scale-100 opacity-100" : "scale-75 opacity-0"}`}
      >
        <h1 className="text-white text-lg font-bold">{title}</h1>
        <p className="text-white text-md mt-1">{message}</p>
        <div
          className="absolute bottom-0 left-0 h-2 bg-link rounded-b-md transition-all duration-[5000ms]"
          style={{ width: progressWidth }}
        />
      </div>
    </div>
  );
}
